var HeightVisual = {
    conf: {
        animSpeed: 400,
        headHeight: 0
    },
    init: function(n) {
        var self = this;
        var conf = self.conf;
        switch(n) {
            case "":
                var w = $(window).width();
                // console.log("w:"+w);
                var ch = self.getContentsHeight();
                self.setHeight('.fn-main-visual', ch);
                var subH = self.getSubHeaderHeight('.main-sub-header');
                var h1h = self.getH1Y('.main-text',ch,w,subH);
                self.setH1Y('.main-text',h1h);
                self.getCampaignPadding('.fn-intro','.fn-intro-area',w);
                break;
        }
    },
    getContentsHeight: function() {
        // console.log("getContentsHeight");
        // console.log($(window).height());
        
        var headerHeight = $("header").innerHeight();
        // console.log("headerHeight:"+headerHeight)
        var hh = $(window).height() - headerHeight;
        return hh;
    },
    getH1Y: function(elem,ch,ww,subH){
        var w = ww;
        var h1h = $(elem).outerHeight();
        // console.log("h1h:"+h1h);
        var hh = 0;
        var xx = 768;
        var yy = 524;
        var y = yy * w / xx;
        var minW = 373;
        // minW = 403;
        // if(w <= 768 && w > minW) {
        //     hh = yy * w / xx;
        //     // hh = ch - h1h;
        //     if((hh+h1h) > ch) {
        //         hh = ch - h1h;
        //     }
        // }else if(w <= minW) {
        //     hh = yy * minW / xx;

        // }else {
        //     hh = (ch - h1h) / 2 + (subH/2);
        // }
        hh = (ch - h1h) / 2 + (subH/2);
        // console.log("hh:"+hh);
        return hh;
    },
    getSubHeaderHeight: function(elem) {
        var subHeaderHeight = $(elem).innerHeight();
        return subHeaderHeight;
    },
    setHeight: function(elem,height) {
        $(elem).css({'padding-top': height +'px'});
    },
    setH1Y: function(elem,height) {
        $(elem).css({'top': height +'px'});
    },
    getCampaignPadding: function(elem,elemArea,w) {
        // console.log("getCampaignPadding:"+w);
        if(w >= 1030) {
            var areaW = $(elemArea).width();
            var p = ((w/2) - areaW)/2;
            // w / 2;
            $(elem).css({'padding-left': p +'px'});
        }else {
            $(elem).css({'padding-left':'20px'});
        }
    }
};

module.exports = HeightVisual;